module.exports = __webpack_public_path__ + "static/fonts/AppleSDGothicNeoL.417b220.woff";